import { Navigate, useLocation } from "react-router-dom";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, authStatus, retryVerification } = useAuth();
  const location = useLocation();
  if (authStatus === "checking") return <Box role="status" sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}><CircularProgress aria-label="Checking your account" /></Box>;
  if (authStatus === "unavailable") return <Box component="main" sx={{ maxWidth: 520, mx: "auto", px: 2, pt: 18 }}><Alert severity="warning" sx={{ fontSize: 17 }}>We can't check your account right now. Check your connection, then try again.</Alert><Button variant="contained" onClick={retryVerification} sx={{ mt: 2, minHeight: 52 }}>Try again</Button></Box>;
  return user ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
